module.exports = __webpack_public_path__ + "img/google.1e6725e8.png";